import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";
import NoGapContentpoints from "../../Components/sub-pages/NoGapContent_point";

const EmployeeGifts = () => {
  const CTAContent = [
    {
      pageName: "Employee Gifts ",
      paragraphitalic: "Celebrate Your Workforce",
      paragraphText:
        "Reward and motivate your employees with branded merchandise that acknowledges their contributions and strengthens company culture. From onboarding kits to festive gifts, we have options for every occasion.",
      ContactFormName: "Employee Gifts",
    },
  ];

  const SubpgesLeftContent = [
    {
      index: 0,
      sectionName: "Onboarding Kits",
      parapgraphItalic: "Create a warm welcome for new hires.",
      sectionparagraphText: (
        <>
          <p>
            Set the tone for a positive workplace experience with personalized
            gifts that speak to your company culture.
          </p>
          <p>
            Starting a new job is exciting, and the first day sets the stage for
            a long and successful journey. And we help you create a memorable
            onboarding experience with custom kits designed to make your new
            hires feel welcomed from day one.
          </p>
        </>
      ),
      ImgSrc: "../assests/images/employee-gifts/Onboarding Kits.jpg",
    },
    {
      index: 1,
      sectionName: "Festive Celebrations",
      parapgraphItalic: "Add joy to special occasions.",
      sectionparagraphText: (
        <>
          <p>
            Make every festival and holiday more special with handpicked gifts
            that add cheer and reflect your company’s spirit.
          </p>
          <p>
            Festive occasions are the perfect opportunity to show appreciation
            and spread joy within your team. Whether it’s Diwali, Christmas, or
            any other special event, eYantra offers a wide selection of festive
            gifts that are sure to delight.
          </p>
        </>
      ),
      ImgSrc: "../assests/images/employee-gifts/Festive Celebrations.jpg",
      categoryHeadingLeftSide: "Our Festive Gift Ideas Include:",
      CategoriesLeftContent: [
        {
          CategoryImg: "../assests/images/employee-gifts/Festival-Specific Hampers.png",
          CategoryName: (
            <>
              <p className="fs-14">
                <b>Festival-Specific Hampers</b> <br></br>
              </p>
            </>
          ),
        },
        {
          CategoryImg: "../assests/images/employee-gifts/Decorative Gifts.png",
          CategoryName: <>
          <p className="fs-14">
            <b>Decorative Gifts</b> <br></br>
          </p>
        </>,
        },
        {
          CategoryImg: "../assests/images/employee-gifts/Exclusive Vouchers and Experiences.png",
          CategoryName: <>
          <p className="fs-14">
            <b>Exclusive Vouchers and Experiences</b> <br></br>
          </p>
          </>,
        },
      ],
    },
  ];

  const noGapContent = [
    {
      RightImgNogap: "../assests/images/employee-gifts/What's Inside Our Onboarding Kits.jpg",
      NogapHeading: "What's Inside Our Onboarding Kits?",
      Heading: [
        {
          ListHeading: "Personalized Welcome Gifts",
          ListParagraph: "Custom notebooks, pens, and company swag",
        },
        {
          ListHeading: "Tech Essentials",
          ListParagraph: "Earbuds, chargers, or branded USB drives ",
        },
        {
          ListHeading: "Office Comforts",
          ListParagraph: "Cushions, mugs, and reusable water bottles",
        },
      ],
      NogapSubheading: "Why Onboarding Kits Matter: ",
      Categories: [
        {
          ServiceImg: "../assests/images/employee-gifts/Boost Morale.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Boost Morale</b> 
              </p>
            </>
          ),
        },
        {
          ServiceImg: "../assests/images/employee-gifts/Encourage Team Spirit.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Encourage Team Spirit</b> 
              </p>
            </>
          ),
        },
        {
          ServiceImg: "../assests/images/employee-gifts/Set the Right Tone.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Set the Right Tone</b>
              </p>
            </>
          ),
        },
      ],
    },

    /**new index */
    {
      RightImgNogap: "../assests/images/employee-gifts/Milestone Recognition.jpg",
      NogapHeading: "Milestone Recognition ",
      paragraphItalic: "Make sure every gift reflects excellence.",
      paragraphDetail: (
        <>
          <p>
          Appreciate dedication and achievements. 
          </p>
          <p>
            Show appreciation for the hard work and dedication that goes into every achievement. 
          </p>
          <p>
          Milestones such as work anniversaries, project completions, and promotions deserve to be celebrated. At eYantra, we provide a range of premium milestone gifts that are as unique as the achievements. 
          </p>
        </>
      ),

      NogapSubheading: "Our Milestone Gift Options Include:",
      Categories: [
        {
          ServiceImg: "../assests/images/employee-gifts/Personalized Awards.png",
          ServiceText: (
            <>
                 
                <p className="fs-14">
                <b>Personalized Awards</b>
              </p>
            </>
          ),
        },
        {
          ServiceImg: "../assests/images/employee-gifts/Luxury Gift Hampers.png",
          ServiceText: (
            <>
            <p className="fs-14">
                <b>Luxury Gift Hampers</b> 
              </p>
                 
            </>
          ),
        },
        {
          ServiceImg: "../assests/images/employee-gifts/2.png",
          ServiceText: (
            <>
                <p className="fs-14">
                <b>Experience Gifts</b>
              </p>

            </>
          ),
        },
      ],
    },
  ];

  const NoGapContentPoints = [
    {
      RightImgNogap: "../assests/images/employee-gifts/Why Festive Gifts Matter.jpg",
      NogapHeading: "Why Festive Gifts Matter:",
      Heading: [
        {
          ListHeading: "Create Connection",
          ListParagraph:
            "Gift-giving fosters camaraderie and strengthens team bonds.",
        },
        {
          ListHeading: "Show Appreciation",
          ListParagraph: "Recognizing special occasions makes employees feel motivated.",
        },
        {
          ListHeading: "Celebrating Culture",
          ListParagraph:
            " Align your gifts with the festive spirit and your company’s values.",
        },
      ],
    },
    {
      RightImgNogap: "../assests/images/employee-gifts/Why Milestone Recognition Matters.jpg",
      NogapHeading: "Why Milestone Recognition Matters: ",
      Heading: [
        {
          ListHeading: "Employee Engagement",
          ListParagraph:
            "Acknowledge hard work to foster loyalty and motivation.",
        },
        {
          ListHeading: "Positive Work Culture",
          ListParagraph: "Celebrating milestones shows that you care about your team’s success.",
        },
        {
          ListHeading: "Personalized Appreciation",
          ListParagraph:
            "Tailored gifts make employees feel seen for their contributions.",
        },
      ],
    },
  ];
  return (
    <>
      <Helmet>
        <title>eYantra Employee & Corporate Gifting</title>
        <meta name="description" content="eYantra delivers branded merchandise, welcome kits, joining kits, and personalised business items for employee gifting and corporate gifting needs."/>
        <meta name="keywords" content="eyantra, branded merchandise, employee gifting ,corporate gifting, joining kits,  corporate gifts, corporate gifts for employees, welcome kits, employee gifts, personalised business items "/>
      </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NoGapContentpoints data={NoGapContentPoints[0]} />
      <NogapleftImg data={noGapContent[1]} />
      <NoGapContentpoints data={NoGapContentPoints[1]} />
      </div>
      <p className="text-center fs-32 w-75 d-block m-auto py-5">
      Show your team you value them with meaningful gifts that boost workplace satisfaction. 
      </p>
    </>
  );
};

export default EmployeeGifts;
